/**
 * CS 21.28 -- Share flow: multi-select on the grid → PDF/Excel DOWNLOAD.
 *
 * The OS share sheet is intentionally not used; users get a file in their
 * Downloads and forward it themselves. This keeps the flow identical on
 * mobile and desktop, and works when the app is opened in an in-app browser.
 */

function _downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/** Single-piece card image download (JPEG). */
export async function downloadSingleCard({
  apiBase, tokenKind, token, jewelCode, view = "staff", pin,
  withPrice = true,
}) {
  const url = new URL(`${apiBase}/public/${tokenKind}/${token}/share/card/${encodeURIComponent(jewelCode)}`);
  url.searchParams.set("with_price", withPrice ? "true" : "false");
  if (view === "owner" && pin) {
    url.searchParams.set("view", "owner");
    url.searchParams.set("pin", pin);
  }
  const r = await fetch(url.toString(), { cache: "no-store" });
  if (!r.ok) throw new Error(`Card request failed: ${r.status}`);
  const blob = await r.blob();
  _downloadBlob(blob, `${jewelCode}.jpg`);
}

/** Bulk (multi-piece) share as PDF or XLSX. */
export async function downloadBulkShare({
  apiBase, tokenKind, token, jewelCodes,
  format = "pdf", withPrice = true, selectedTiers = null, view = "staff", pin,
}) {
  if (!["distributor", "retailer"].includes(tokenKind)) {
    throw new Error("bulk share is wired for distributor / retailer links only");
  }
  const url = `${apiBase}/public/${tokenKind}/${token}/share/bulk`;
  const r = await fetch(url, {
    method: "POST",
    cache: "no-store",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      jewel_codes: jewelCodes,
      format,
      with_price: withPrice,
      selected_tiers: selectedTiers,
      view,
      pin: pin || null,
    }),
  });
  if (!r.ok) {
    let msg = `${r.status}`;
    try { msg = (await r.json()).detail || msg; } catch { /* ignore */ }
    throw new Error(msg);
  }
  const blob = await r.blob();
  const stamp = new Date().toISOString().slice(0, 10);
  const ext = format === "xlsx" ? "xlsx" : "pdf";
  _downloadBlob(blob, `ashth-${jewelCodes.length}-pieces-${stamp}.${ext}`);
}
